import { Navigate, Outlet } from "react-router";
import { useFoodpilotContext } from "src/context/FoodpilotContext";

export const PlatformAdminProtection = () => {
    const { isAdmin } = useFoodpilotContext();

    if (!isAdmin()) {
        return <Navigate to="/settings" replace />;
    }

    return <Outlet />;
};
